import type { ExtendedBid, ExtendedBidPtu, Ptu } from '@/features/bidding/types/bid'

/**
 * We can't just compare PTUs from energy bids with PTUs from capacity bids
 * because the PTU duration might be different (for example: 1h for capacity and 15m for energy)
 * This function returns the capacity bid PTU that best matches the start time of an energy bid PTU
 */
export function capacityPtuFor(capacityBid: ExtendedBid, energyBidPtu: Ptu): ExtendedBidPtu | undefined {
  // capacity bid
  let capacityPtu: ExtendedBidPtu | undefined = undefined
  for (const bidPtu of capacityBid.ptus ?? []) {
    // if the start time matches exactly, return that PTU
    if (bidPtu.ptu.start.equals(energyBidPtu.start)) {
      capacityPtu = bidPtu
      break
    }
    // if only the hour matches save that PTU as best candidate
    if (bidPtu.ptu.start.hour === energyBidPtu.start.hour) {
      capacityPtu = bidPtu
    }
  }

  return capacityPtu
}
